import { Id, MessagesResponse } from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { useChatWebsocketContext } from 'chat/websocket/context'
import { removeMessageDataFromCache } from './shared/utils'

type Variables = {
  conversationId: Id
  messageId: Id
}

export function useDeleteMessage() {
  const { server } = useServer()
  const client = useQueryClient()
  const { sendWebsocketMessage } = useChatWebsocketContext()

  return useMutation({
    mutationFn: deleteMessage,
    onSuccess: async event => {
      await removeMessageDataFromCache(client, event)
      sendWebsocketMessage({
        action: 'sendMessageEvent',
        messageEvent: event,
      })
    },
  })

  function deleteMessage({ conversationId, messageId }: Variables) {
    return server.delete<MessagesResponse.RemoveMessageEvent>(
      `/v2/chat/conversations/${conversationId}/messages/${messageId}`
    )
  }
}
